



























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Borough } from "../model/Boroughs";
import {Gender, isNorthEastAndNorthCumbria} from "../model/Model";

@Component
export default class DrinkCoachAppointment extends Vue {
  public static navButtonClasses: string[] = ["book-appointment"];
  public static navButtonLabel(region: Borough | undefined): string {
    if ((region && !!region.hasFreeAppointments) || isNorthEastAndNorthCumbria()) {
      return "Book a FREE online appointment with a DrinkCoach";
    }
    return "Book an online appointment with a DrinkCoach";
  }

  @Prop() public score!: number;
  @Prop() public units!: number;
  @Prop() public calories!: number;
  @Prop() public gender!: Gender;
  @Prop() public region!: Borough;
  @Prop() public commissioned!: boolean;
  @Prop() public isMobile!: boolean;

  public get hasFreeAppointments(): boolean {
    return !!this.region.hasFreeAppointments;
  }

  public get bookingLiveLink(): string {
    switch (this.region.name) {
      case "West Sussex":
        return "https://drinkcoach.bookinglive.com/book/add/p/11";
      case "Suffolk":
        return "https://drinkcoach.bookinglive.com/book/add/p/29";
      case "Rotherham":
        return "https://drinkcoach.bookinglive.com/book/add/p/22";
      case "Essex":
        return "https://drinkcoach.bookinglive.com/book/add/p/24";
      case "Barnet":
        return "https://drinkcoach.bookinglive.com/book/add/p/14";
      case "Lambeth":
        return "https://drinkcoach.bookinglive.com/book/add/p/15";
      case "NorthEastAndNorthCumbria":
        return "https://drinkcoach.bookinglive.com/book/add/p/19";
      case "Lewisham":
        return "https://drinkcoach.bookinglive.com/book/add/p/16";
      case "Haringey":
        return "https://drinkcoach.bookinglive.com/book/add/p/20";
      case "Waltham Forest":
        return "https://drinkcoach.bookinglive.com/book/add/p/18";
      case "Barnsley":
        return "https://drinkcoach.bookinglive.com/book/add/p/13";
      case "Croydon":
        return "https://drinkcoach.bookinglive.com/book/add/p/31";
      case "Bradford District":
        return "https://drinkcoach.bookinglive.com/book/add/p/32";
      case "Oxfordshire":
        return "https://drinkcoach.bookinglive.com/book/add/p/33";
      default:
        return "https://drinkcoach.bookinglive.com/";
    }
  }
}
